const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  // avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  storeInfo: state => state.user.store_info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  // 站点配置文件
  publicConfig: () => window.publicConfig
}

export default getters
